export type AppEnvironment = 'local' | 'dev' | 'staging' | 'prod';

/**
 * Which environment this tab is talking to, from the hostname. Changes made on
 * localhost only touch the local DB — the badge makes that impossible to miss.
 */
export function appEnvironmentFromHost(hostname: string): AppEnvironment {
  if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.endsWith('.localhost')) return 'local';
  if (hostname.startsWith('dev.') || hostname.includes('-dev')) return 'dev';
  if (hostname.includes('staging')) return 'staging';
  return 'prod';
}
